/*
CSS Browser Selector js v0.5.3 (July 2, 2013)

-- original --
Rafael Lima (http://rafael.adm.br)
http://rafael.adm.br/css_browser_selector
  License: http://creativecommons.org/licenses/by/2.5/
    Contributors: http://rafael.adm.br/css_browser_selector#contributors
      -- /original --

Fork project: http://code.google.com/p/css-browser-selector/
  Song Hyo-Jin (shj at xenosi.de)
*/
function css_browser_selector(u) {
  var ua = u.toLowerCase(),
    is = function(t) {
      return ua.indexOf(t) > -1
    },
    g = 'gecko',
    w = 'webkit',
    s = 'safari',
    c = 'chrome',
    o = 'opera',
    m = 'mobile',
    v = 0,
    r = window.devicePixelRatio ? (window.devicePixelRatio + '').replace('.', '_') : '1';
  var res = [
    /* IE */
    (!(/opera|webtv/.test(ua)) && /msie\s(\d+)/.test(ua) && (v = RegExp.$1 * 1)) ?
      ('ie ie' + v + ((v == 6 || v == 7) ?
        ' ie67 ie678 ie6789' : (v == 8) ?
          ' ie678 ie6789' : (v == 9) ?
            ' ie6789 ie9m' : (v > 9 ) ?
              ' ie9m' : '')) :
      /* IE 11 */
      (/trident\/\d+.*?;\s*rv:(\d+)\.(\d+)\)/.test(ua) && (v = [RegExp.$1, RegExp.$2])) ?
        'ie ie' + v[0] + ' ie' + v[0] + '_' + v[1] + ' ie9m' :
        /* FF */
        (/firefox\/(\d+)\.(\d+)/.test(ua) && (re = RegExp)) ?
          g + ' firefox firefox' + re.$1 + ' firefox' + re.$1 + '_' + re.$2 :
          is('gecko/') ? g :
            /* Opera */
            is(o) ? o + (/version\/(\d+)/.test(ua) ? ' ' + o + RegExp.$1 :
              (/opera(\s|\/)(\d+)/.test(ua) ? ' ' + o + RegExp.$2 : '')) :
              /* K */
              is('konqueror') ? 'konqueror' :
                /* Black Berry */
                is('blackberry') ? m + ' blackberry' :
                  /* Chrome */
                  (is(c) || is('crios')) ? w + ' ' + c :
                    /* Iron */
                    is('iron') ? w + ' iron' :
                      /* Safari */
                      !is('cpu os') && is('applewebkit/') ? w + ' ' + s :
                        /* Mozilla */
                        is('mozilla/') ? g : '',
    /* Android */
    is('android') ? m + ' android' : '',
    /* Tablet */
    is('tablet') ? 'tablet' : '',
    /* Machine */
    is('j2me') ? m + ' j2me' :
      is('ipad; u; cpu os') ? m + ' chrome android tablet' :
        is('ipad;u;cpu os') ? m + ' chromedef android tablet' :
          is('iphone') ? m + ' ios iphone' :
            is('ipod') ? m + ' ios ipod' :
              is('ipad') ? m + ' ios ipad tablet' :
                is('mac') ? 'mac' :
                  is('darwin') ? 'mac' :
                    is('webtv') ? 'webtv' :
                      is('win') ? 'win' + (is('windows nt 6.0') ? ' vista' : '') :
                        is('freebsd') ? 'freebsd' :
                          (is('x11') || is('linux')) ? 'linux' : '',
    /* Ratio (Retina) */
    (r != '1') ? ' retina ratio' + r : '',
    'js portrait'].join(' ');
  if(window.jQuery && !window.jQuery.browser) {
    window.jQuery.browser = v ? {msie: 1, version: v} : {};
  }
  document.documentElement.className += ' ' + res;
};
css_browser_selector(navigator.userAgent);

$(document).ready(()=>{

  $('select').selectric();

  $('body').on('click','.open_popup',function(e){
    e.preventDefault();
    if($(this).attr('data-target'))$($(this).attr('data-target')).openPopup();
  });

  $('body').on('click','.popup a.close',function(e){
    e.preventDefault();
    $(this).closest('.popup').closePopup();
  });

  //tabs
  $('body').on('click','.tabs[data-target] > *:not(.active)',function(e){
    e.preventDefault();
    const tab_parent =  $(this).closest('.tabs'),
      target = tab_parent.attr('data-target');
    if(tab_parent.length > 0 && target){

      const tab = $(this),
        tabs = tab_parent.find('>*'),
        index = tabs.index(tab),
        content = $(target).find('>*');

      tabs.removeClass('active');
      content.removeClass('active');

      tab.addClass('active');
      content.eq(index).addClass('active');
    }
  });


  $("form.validation").validationEngine({
    showPrompts:false,
    addFailureCssClassToField:"error"
  });

  if($('.faq_page').length){
    $('.faq_page .item h3').click(function(){
      var item = $(this).parent();
      if(item.hasClass('open'))item.removeClass('open');
      else item.addClass('open');
    });
  }
  $('[data-mask]').each(function(){
    const type = $(this).data('mask');
    switch (type){
      case "phone":
        $(this).inputmask({
					showMaskOnHover:false,
          mask: "0*-999-99-99",
          definitions: {
            '9': {
              validator: "[0-9]",
              cardinality: 1,
              casing: "lower"
            },
            '*':{
              validator:"(50|51|55|60|70|77|10)",
              cardinality: 2,
            }
          }
        });
        break;
      case "number":
      case "decimal":
      case "integer":
        $(this).inputmask(type, { rightAlign: false });
        break
    }
  });

  $('[data-maps]').each(function(){
    const id = $(this).attr('id');
    const coords = {lat:$(this).attr('data-lat')*1,lng:$(this).attr('data-lng')*1};
    const zoom = $(this).attr('data-zoom') ? $(this).attr('data-zoom')*1 : 11;
    $.maps.load(()=>{
      const map = new google.maps.Map(document.getElementById(id), {
        zoom: zoom,
        center: coords
      });
      const marker = new google.maps.Marker({
        position: coords,
        icon:'/images/map/select_map_pin.png'
      });
      // adds the marker on the map
      marker.setMap(map);
    });
  });




  if($("#home_slider").length>0){
    const home_slider = $("#home_slider");
    home_slider.owlCarousel({
      margin:0,
      responsiveClass:true,
      nav:false,
      dots:false,
      navText:['',''],
      responsive:{
        0:{
          items:1,
        }
      }
    });

    const home_slider_items = $("#home_slider .item");
    home_slider_items.each(function(){
      $('<div class="btn"><button class="prev"></button><button class="next"></button></div>').appendTo($(this).find('>div'));
    });

    $("#home_slider .item .btn button").click(function(){
      if($(this).hasClass('prev'))home_slider.trigger('prev.owl.carousel');
      else home_slider.trigger('next.owl.carousel');
    });

  }



  if($('.brends_carousel').length>0){
    $('.brends_carousel .owl-carousel').owlCarousel({
      margin:0,
      responsiveClass:true,
      nav:true,
      dots:false,
      navText:['',''],
      responsive:{
        0:{
          items:1,
        },
        550:{
          items:2,
        },
        767:{
          items:3,
        },
        991:{
          items:5,
        }
      }
    });
  }
	if($('.marketinq-support .other-services').length>0){
		$('.marketinq-support .other-services .items').owlCarousel({
			margin:24,
			responsiveClass:true,
			nav:true,
			dots:false,
			navText:['',''],
			responsive:{
				0:{
					items:1,
				},
				550:{
					items:2,
				},
				767:{
					items:3,
				},
				991:{
					items:4,
				}
			}
		});
	}

	if($('.blog_detail_page .owl-carousel').length>0){
		$('.blog_detail_page .owl-carousel').owlCarousel({
			margin:30,
			responsiveClass:true,
			nav:true,
			dots:false,
			navText:['',''],
			responsive:{
				0:{
					items:3,
				}
			}
		});
	}

	if($('.vacancy .item').length){
    $('.vacancy .item .toggle').click(function(){
      const item = $(this).closest('.item');
      if(item.hasClass('active'))item.removeClass('active').find('.body').removeAttr('style');
      else {
        item.addClass('active').find('.body').css('max-height',item.find('.text').outerHeight());
      }
    });
    if(!$.is_mobile)$('.vacancy .item').each(function(index,item){
      if(index<2)return;
      const parent = $(item).parent();
      $(item).appendTo($('.vacancy .row .col-md-6').eq(index%2));
      parent.remove();
    });
  }

	$(document).on('mobile_on',()=>{
	  if($('.home_bg .product_list,.other_product .product_list').length>0){
      $('.product_list').each(function(){
        if($(this).find('.owl-carousel').length)return;

        const owl = $('<div class="owl-carousel"></div>');
        $(this).find('>*').appendTo(owl);
        owl.appendTo(this);
        owl.owlCarousel({
          margin:30,
          responsiveClass:true,
          nav:true,
          dots:false,
          navText:['',''],
          responsive:{
            0:{
              items:1,
            }
          }
        });
      });
    }
  });

	$('.open_mobile_menu').click(function(){
		$('#header nav').addClass('open');
	});
	$('.close_mobile_menu').click(function(){
		$('#header nav').removeClass('open');
	});

  var media = window.matchMedia("(max-width: 991px)");
  mobileSupport(media);
  media.addListener(mobileSupport);

  $('[data-match-height]').each(function () {
    $(this).find($(this).attr('data-match-height')).matchHeight();
  });
});
$.fn.openPopup = function(){
  const elem = $(this);
  if(elem.length>0) {
    const opened_popup = $('.popup').filter('.show');

    if(opened_popup.length)opened_popup.closePopup();

    elem.addClass('show');
    setTimeout(() => elem.addClass('animate'), 1);
    elem.trigger('openPopup');
  }
};
$.fn.closePopup = function(){
  const elem = $(this);
  if(elem.length>0) {
    elem.removeClass('animate');
    setTimeout(()=>elem.removeClass('show'),400);
    elem.trigger('closePopup');
  }
};

$.maps = {
  key:window.MAPS_API_KEY,
  loaded: false,
  loading: false,
  callbacks : [],
  load(callback){
    $.maps.add_callback(callback);
    if($.maps.loaded)$.maps.run_callback();
    else if(!$.maps.loading){
      $.maps.loading = true;
      $.getScript('https://maps.googleapis.com/maps/api/js?key='+ $.maps.key +'&callback=$.maps.ready&language=az&region=AZ');
    }
  },
  ready(){
    $.maps.loaded = true;
    $.maps.run_callback();
  },
  add_callback(fn){
    if(typeof fn !== 'undefined')$.maps.callbacks.push(fn);
  },
  run_callback(){
    if($.maps.callbacks.length>0){
      $.each($.maps.callbacks,(index,callback)=>{
        if($.isFunction(callback))callback();
        else if(typeof window[callback] !== "undefined")window[callback]();
      });
      $.maps.callbacks = [];
    }
  }
};

$.is_mobile = false;
const mobileSupport = media => {
  if (media.matches){
    $.is_mobile = true;

		$('body').on('click','#header nav li:has(ul) > a',function(e){
			e.preventDefault();
			var li = $(this).parent();
			if(li.hasClass('active'))li.find('ul').animate({height:0},500,function(){ li.removeClass('active'); });
			else {
				li.addClass('active');

				li.find('ul').animate({height:li.find('li').length*li.find('li').first().outerHeight()},500);
			}
		});

		const search_lang = $('<div class="search_lang_mobile"/>').appendTo('#header .inner > div');
		$('#header .search').appendTo(search_lang);
		$('#header .lang').appendTo(search_lang);

		$('#header .top .search .toggle').off('click');
		$('#header .inner > div .search .toggle').off('click').on('click', function(){
			if($('#header .inner > div').hasClass('search_open')){
				$('#header .inner > div').removeClass('animate');
				setTimeout(() => $('#header .inner > div').removeClass('search_open'), 400);
			}
			else {
				$('#header .inner > div').addClass('search_open');
				setTimeout(() => $('#header .inner > div').addClass('animate'), 10);
			}
		});

		$('#header .contact').appendTo('#header nav');

    $(document).trigger('mobile_on');
  }
  else{
    $.is_mobile = false;
		$('body').off('click','#header nav li:has(ul) > a');

		$('#header .inner > div .search .toggle').off('click');
		$('#header .top .search .toggle').off('click').on('click', function(){
			if($('#header .top').hasClass('search_open')){
				$('#header .top').removeClass('animate');
				setTimeout(() => $('#header .top').removeClass('search_open'), 400);
			}
			else {
				$('#header .top').addClass('search_open');
				setTimeout(() => $('#header .top').addClass('animate'), 10);
			}
		});
		$('#header .contact').appendTo('#header .top .container');
		$('#header .search').appendTo('#header .top .container');
		$('#header .lang').appendTo('#header .top .container');
		$('.search_lang_mobile').remove();

    $(document).trigger('mobile_off');
  }
};